import SFetch from '@app/utils/sfetch'
import type {
  ExistingCompanyLinkResponse,
  AvailableCompanyResponse,
  CreateCompanyLinkResponse,
  SelectorModalExternalCompaniesParams,
  SelectorModalExternalCompaniesResponse,
} from '../types'

export const createCompanyLink = async ({
  sourceCompanyId,
  userId,
}: {
  sourceCompanyId: number
  userId: number
}): Promise<CreateCompanyLinkResponse | null> => {
  const url = window.Silverfin.Routes.company_links_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return await SFetch.json(url, {
    method: 'POST',
    body: {
      company_link: {
        source_company_id: sourceCompanyId,
        user_id: userId,
      },
    },
  })
}

export const deleteCompanyLink = async ({
  sourceCompanyId,
}: {
  sourceCompanyId: number
}): Promise<null> => {
  const url = window.Silverfin.Routes.company_link_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    sourceCompanyId
  )

  return await SFetch.json(url, {
    method: 'DELETE',
  })
}

export const getExistingCompanyLinks =
  async (): Promise<ExistingCompanyLinkResponse | null> => {
    const url = window.Silverfin.Routes.existing_links_company_links_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )

    return await SFetch.json<ExistingCompanyLinkResponse>(url)
  }

export const getAvailableCompanies =
  async (): Promise<AvailableCompanyResponse | null> => {
    const url = window.Silverfin.Routes.available_companies_company_links_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )

    return await SFetch.json<AvailableCompanyResponse>(url)
  }

export const getExternalCompaniesSelectorModal = async ({
  value,
  defaultValue,
}: SelectorModalExternalCompaniesParams): Promise<SelectorModalExternalCompaniesResponse | null> => {
  const body = {
    value,
    default_value: defaultValue,
  }

  const url =
    window.Silverfin.Routes.external_companies_selector_modal_company_links_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )

  return await SFetch.json<SelectorModalExternalCompaniesResponse>(url, {
    method: 'POST',
    body,
  })
}
